import React from 'react';
import { IMeetingsCancellingJobResult, IMeetingsJobDetails } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';

const meetingsCancelJobProperties: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<
    IMeetingsJobDetails,
    IMeetingsCancellingJobResult
>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: (props: IJobResultComponentProps<IMeetingsJobDetails, IMeetingsCancellingJobResult>) => {
        return <>{props.result.cancelledMeetings} meetings have been cancelled</>;
    },
    failedComponent: () => {
        return <>Meeting Cancellation Failed</>;
    }
};

export { meetingsCancelJobProperties };
